module.exports = __webpack_public_path__ + "static/media/Arcade_6231.31ba1806.jpg";